export default "__VITE_ASSET__NP$GXUjk__"